import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import HorseProfileTable from './HorseProfileTable';

export default class HorseProfileEntriesPage extends Component {
  static propTypes = {
    profile: PropTypes.object
  };

  render() {
    const {
      profile = {},
      profile: {
        name
      } = {}
    } = this.props;

    return (
      <div className="horse-profile-results">
        <MetaDataWrapper title={`${name} - Horse Future Entries`}/>
        <HorseProfileTable profile={profile} earlyEntries />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/HorseProfileEntriesPage.js